import { dataResponse, deleteResponse, errorCodeResponse, errorResponse } from './utils/response-templates.js';
import { ErrorCodes } from './error-codes.js';
import { z } from './utils/zod.js';
export const C2PA_ALLOWED_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'video/mp4',
    'video/quicktime',
    'video/x-msvideo',
    'audio/mpeg',
    'audio/wav',
];
export const c2paStatusResponseSchema = dataResponse(z.object({
    enabled: z.boolean(),
}));
export const signC2paMediaRequestSchema = z.object({
    file: z.instanceof(File),
});
export const c2paSigningDtoSchema = z.object({
    id: z.string(),
    filename: z.string(),
    contentType: z.string(),
    byteSize: z.string(),
    createdAt: z.string(),
    expiresAt: z.string(),
});
export const signC2paMediaResponseSchema = dataResponse(c2paSigningDtoSchema);
export const listC2paSigningsResponseSchema = dataResponse(z.array(c2paSigningDtoSchema));
export const verifyC2paMediaRequestSchema = z.object({
    file: z.instanceof(File),
});
// Raw c2patool manifest-store report; null when the file carries no manifest.
export const verifyC2paMediaResponseSchema = dataResponse(z.object({
    report: z.record(z.string(), z.unknown()).nullable(),
}));
export const deleteC2paSigningResponseSchema = deleteResponse();
export const c2paDisabledResponseSchema = errorCodeResponse(ErrorCodes.EC2paDisabled, 'C2PA signing is not available');
export const c2paInvalidFileResponseSchema = errorResponse('Only image, video and audio files are allowed');
export const c2paSigningNotFoundResponseSchema = errorCodeResponse(ErrorCodes.EDocumentNotFound, 'Signed file not found');
export const c2paRateLimitResponseSchema = errorCodeResponse(ErrorCodes.EC2paRateLimitReached, 'Daily C2PA signing limit reached');
